import "core-js/modules/es.object.to-string";
import { listNo, productList } from "@/api/advRelation";
import { advertChannelManageData, callbackSwitchConfigManageData, eventManageData, callbackEventReflectionManageData } from "@/api/financial/backhaul";
export default {
  props: {},
  data: function data() {
    return {
      searchData: {},
      productLists: [],
      advertChannelData: [],
      callbackSwitchConfigData: [],
      eventManageDataList: [],
      callbackEventReflectionManageDataList: [],
      productList: []
    };
  },
  activated: function activated() {},
  created: function created() {},
  watch: {},
  computed: {},
  methods: {
    getListNo: function getListNo() {
      var _this = this;

      listNo().then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg'];
          _this.productLists = res.data.length ? _this.$utils.dataConversion(res.data, list) : [];
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      productList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.productList = res.data;
        }
      });
    },
    getadvertChannelManageData: function getadvertChannelManageData() {
      var _this3 = this;

      advertChannelManageData().then(function (res) {
        if (res.status == 200) {
          _this3.advertChannelData = res.data;
        }
      });
    },
    getcallbackSwitchConfigManageData: function getcallbackSwitchConfigManageData() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        callbackSwitchConfigManageData().then(function (res) {
          if (res.status == 200) {
            _this4.callbackSwitchConfigData = res.data;
            resolve();
          }
        });
      });
    },
    geteventManageData: function geteventManageData(e) {
      var _this5 = this;

      eventManageData(e).then(function (res) {
        if (res.status == 200) {
          _this5.eventManageDataList = res.data;
        }
      });
    },
    gettes: function gettes() {
      var _this6 = this;

      callbackEventReflectionManageData().then(function (res) {
        if (res.status == 200) {
          _this6.callbackEventReflectionManageDataList = res.data;
        }
      });
    }
  }
};